import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom'
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import Footerbar from './components/Footerbar';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';
import { useQuery } from '@tanstack/react-query';
import ReactModal from 'react-modal';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import ImageWithLoader2 from './components/ImageWithLoader2';
import InfiniteScroll from "react-infinite-scroll-component";

function SearchFamily() {

  const { isSidebarVisible, showSidebar, toggleSidebar } = useAppLayout();

  const navigate = useNavigate();

  const [selectedFamily, setSelectedFamily] = useState(null);  // Add this line
  const [searchModalOpen, setSearchModalOpen] = useState(false);

  const limit = 20;

  const [families, setFamilies] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [search, setSearch] = useState("");

  const [isFetching, setIsFetching] = useState(false);

  const fetchFamilies = async () => {

    if (isFetching) return;

    setIsFetching(true);
    try {
      const res = await axios.get(`${API_URL}/search-family-api`, {
        params: { q: search, page, limit },
        withCredentials: true,
        // Treat 404 (no results) as a normal empty response so the loader stops cleanly
        validateStatus: (s) => (s >= 200 && s < 300) || s === 404,
      });

      const newData = Array.isArray(res.data?.families) ? res.data.families : [];

      setFamilies((prev) => (page === 1 ? newData : [...prev, ...newData]));
      setHasMore(newData.length === limit);
    } catch (e) {
      console.error("fetch error:", e.response?.data || e.message);
      setHasMore(false);
    }
    finally {
      setIsFetching(false);
    }
  };

  // Reset when search changes
  useEffect(() => {
    setFamilies([]);
    setHasMore(true);
    setPage(1);
  }, [search]);

  // Fetch whenever page or search changes
  useEffect(() => {
    fetchFamilies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, search]);

  const fetchNext = () => setPage((p) => p + 1);

  const showNoResults =
    !isFetching && families.length === 0 && search.trim().length > 0;

  //send message
  const [messageText, setMessageText] = useState('');

  const handleSendMessage = async () => {
    if (!messageText.trim()) {
      
      toast.error("Please enter a message.", { position: "top-right", autoClose: 3000 });
      return;
    }
  
    try {
      const res = await axios.post(`${API_URL}/send-message-to-adminfamily-api`, {
        message: messageText,
        familyCode: selectedFamily.family_code
      });
  
    
      toast.success("Message sent successfully.", { position: "top-right", autoClose: 3000 });
      setMessageText('');
      setSearchModalOpen(false);
      navigate('/chat-list');
      

    } catch (err) {
      //console.error("Failed to send message:", err);
      console.error("Failed to send message:", err.response?.data || err.message || err);
      
      toast.error("Failed to send message.",{ position: "top-right", autoClose: 3000 });
    }
  };



  const modalStyle = {
    overlay: { backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1050 },
    content: {
      
      
      borderRadius: '14px',
     
      overflow: 'hidden',
      maxHeight: '90vh',
    },
  };

  return (

    <div className="scrollPageContainer theme-light">
      <div className="main-wrapper">
      <ToastContainer />
       
        {isSidebarVisible && <Sidebar />}
        <Header toggleSidebar={toggleSidebar} />
        <Sidebar show={showSidebar} toggle={toggleSidebar} />
        <Footerbar toggleSidebar={toggleSidebar} />

        <div className='page-wrapper'>
          

          <div className='content container-fluid'>

          <div
        id="scrollAreaFamily"
        style={{ height: "calc(100vh - 120px)", overflow: "auto", marginBottom: '30px' }} >


               {/* Search Family Card */}
<div className="card border-0 shadow-sm rounded-1 p-1 mb-4 mx-auto" style={{ backgroundColor: '#F7FFF8', }}>
  <div className="card-body text-center">

    {/* Title */}
    <h5 className="fw-bold text-dark mb-1">
      <i className="bi bi-heart-fill text-success me-2"></i>
      Search Family
    </h5>

    {/* Subtitle */}
    <p
  className="text-muted mb-3 small text-truncate"
  style={{ whiteSpace: "nowrap" }}
>
  Search people in your family network.
</p>

    {/* Search Form */}
     
      <div className="input-group" >
        <span className="input-group-text bg-white border-end-0">
          <i className="bi bi-search text-muted"></i>
        </span>
        <input
          type="text"
          className="form-control border-start-0 border-end-0"
          placeholder="Search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ boxShadow: 'none' }}
        />
         
      </div>
     
  </div>
</div>

           


  <div className="row">

      {/* Scroll area + InfiniteScroll */}

      {/*</div><div
        id="scrollAreaFamily"
        style={{ height: "calc(100vh - 120px)", overflow: "auto", marginBottom: '30px' }}
      >*/}

      <div  >

{families.length === 0 && isFetching ? (
    <div className='loadingspinnerDiv'>
    <div className='loadingspinner'></div>
  </div>
  ) : (

        <InfiniteScroll
          dataLength={families.length}
          next={fetchNext}
          hasMore={hasMore}

          loader={<h4 className="text-center py-4">Loading...</h4>}
          endMessage={
            showNoResults ? (
              <div className="text-center text-muted py-5">
                <i className="fas fa-users fa-2x mb-3"></i>
                <div>No results found.</div>
              </div>
            ) : (
              families.length > 0 && (
                <p className="text-center py-4 text-gray-500">
                  <b>No more results</b>
                </p>
              )
            )
          }
          scrollableTarget="scrollAreaFamily"
        >
          {families.map((family) => (
   

<div key={family.id} className="col-md-12" style={{ backgroundColor: '#ffff',  }}>

<div className="col-12 col-md-6">
   
<div className="card border-0 shadow-sm rounded-3 overflow-hidden h-100x family-card position-relative">



        <div className="position-relative">

        <span className="badge bg-white text-dark shadow-sm top-0 start-0 m-2 rounded-pill px-3" style={{ position: "absolute",
    
    left: "10px",
    zIndex: 3,}}>
            {family.totemName || 'Totem'}
          </span>
          
          <div className=""> 

          <ImageWithLoader2 src={`${API_URL}${family.totemImageUrl}`}
       placeholder="https://oret.africa/tree/img/imageplaceholder-icon.jpg"
       fadeDuration={800}
         blurAmount={15} 
          alt={family.name}
           className="w-100 h-100 object-fit-cover"
       />
          </div>
          
        </div>

   <div className="card-body pt-2 pb-4 px-3">

          <h5 className="fw-semibold mb-2">{family.name}</h5>
          <div className="text-muted small mb-2">
            <span className="me-2"><i className="fa-regular fa-flag me-1"></i>{family.tribeName || '—'}</span>
            {family.subtribeName && <span className="ms-2 badge text-bg-light">{family.subtribeName}</span>}
          </div>

          <button
  type="button"
  className="btn btn-sm text-white fw-semibold rounded-0"
  onClick={() => {
    setSelectedFamily(family);
    setSearchModalOpen(true);
  }}
  aria-label={`More info about ${family.name}`}
  style={{
    position: "absolute",
    right: 12,
    bottom: 12,
    backgroundImage: "linear-gradient(135deg, #75B437, #184A2C)",
    border: "none",
    boxShadow: "0 6px 14px rgba(24,74,44,0.18)",
    padding: "8px 14px",
    fontSize: 13,
    lineHeight: 1,
    zIndex: 5,
  }}
>
<i className="bi bi-chat-dots me-1"></i>
Message Admin
</button>



        </div>
      </div>
    </div>



</div>


          ))}


        </InfiniteScroll>

)}

        <div className='row end-page-space' style={{marginBottom: '5%'}}></div>

      </div>




     <ReactModal
      isOpen={searchModalOpen}
      onRequestClose={() => setSearchModalOpen(false)}
      className="Modal"
      overlayClassName="Overlay"
      style={modalStyle}
      ariaHideApp={false}
    >
      {/* Modal header */}
      <div className="modal-header">
        <h5 className="modal-title">Family Details</h5>
        <button type="button" className="btn-close" onClick={() => setSearchModalOpen(false)} />
      </div>
    
      {/* Modal body */}
      <div className="modal-body" style={{ overflowY: 'auto', padding: '1rem' }}>
        {selectedFamily && (
          <>
            {/* Family summary card */}
            <div
              className="rounded-4 p-3 mb-3"
              style={{ backgroundColor: '#EFFFF3', border: '1px solid #DFF7E8' }}
            >
              <div className="d-flex align-items-start justify-content-between">
                <div>
                  <h5 className="fw-semibold mb-1">{selectedFamily.name}</h5>
    
                  
                  {/* chips */}
                  <div className="d-flex gap-2 flex-wrap mt-2">
                    <span className="badge bg-white text-body border rounded-pill">
                      <i className="fa-regular fa-flag me-1"></i>
                      {selectedFamily.tribeName || '—'}
                    </span>
                    {selectedFamily.subtribeName && (
                      <span className="badge bg-white text-body border rounded-pill">
                        {selectedFamily.subtribeName}
                      </span>
                    )}
                    {selectedFamily.totemName && (
                      <span className="badge bg-white text-body border rounded-pill">
                        {selectedFamily.totemName}
                      </span>
                    )}
                  </div>
                </div>
    
                {/* top-right icon bubble */}
                <div
                  className="d-inline-flex align-items-center justify-content-center rounded-4"
                  style={{
                    width: 44,
                    height: 44,
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E6F4EB',
                  }}
                  title="Family"
                >
                  <i className="bi bi-people text-success fs-5"></i>
                </div>
              </div>
            </div>

            
    
            {/* Message box */}
            <div
              className="rounded-4 p-3 mb-3"
              style={{ border: '1px solid #E6EAE8', backgroundColor: '#FFFFFF' }}
            >
              <div className="d-flex align-items-center gap-2 mb-2">
                <i className="bi bi-envelope-open text-muted"></i>
                <span className="fw-semibold">Message to admin</span>
              </div>
    
              <textarea
                className="form-control rounded-3"
                rows={4}
                placeholder="Type your message…"
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                style={{ resize: 'vertical' }}
              />
            </div>
    
            {/* Send button */}
            <div className="d-flex justify-content-end">
              <button
                className="btn text-white fw-semibold rounded-pill px-4 py-2"
                onClick={handleSendMessage}
                style={{
                  backgroundImage: 'linear-gradient(135deg, #75B437, #184A2C)',
                  border: 'none',
                  boxShadow: '0 6px 16px rgba(24,74,44,0.18)',
                }}
              >
                <i className="bi bi-send-fill me-2"></i>
                Send Message
              </button>
            </div>
          </>
        )}
      </div>
    </ReactModal>

            
            
            </div>

            </div>

            
          </div>

        </div>
      </div>

     


    </div>


  );

  
}

export default SearchFamily;
